enum CurrencyConstants {
  GET_CURRENCIES_LIST = "GET_CURRENCIES_LIST",
  GET_CURRENCIES_LIST_SUCCESS = "GET_CURRENCIES_LIST_SUCCESS",
  GET_CURRENCIES_LIST_FAILURE = "GET_CURRENCIES_LIST_FAILURE",
}

export default CurrencyConstants;
